module.exports = fox._r("images/icon-1.png", __webpack_public_path__ + "images/icon-1.png");


//////////////////
// WEBPACK FOOTER
// ./images/icon-1.png
// module id = 164
// module chunks = 5